// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import EyeInvisibleTwoToneSvg from "@ant-design/icons-svg/es/asn/EyeInvisibleTwoTone";
import AntdIcon from '../components/AntdIcon';

var EyeInvisibleTwoTone = function EyeInvisibleTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: EyeInvisibleTwoToneSvg
  }));
};

EyeInvisibleTwoTone.displayName = 'EyeInvisibleTwoTone';
export default React.forwardRef(EyeInvisibleTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/EyeInvisibleTwoTone.js
// module id = 1057
// module chunks = 0